<template>
  <div style="margin: 8px 24px 24px;">
    <div style="display: flex; align-items: center; justify-content: space-between">
      <el-descriptions title="客户信息" border :column="1" size="small" style="width: 50%">
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="称呼" >{{ userForm.name }}</el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="性别" >{{ userForm.sex == 1?'男':userForm.sex == 2?'女':'未知' }}</el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="手机号" >{{ userForm.phone }}</el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="门店" >{{ userForm.shopName}}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions title="总余额" border :column="1" size="small" style="width: 50%">
        <template #title>
          <p>总余额：<span v-if="userForm.userWallet" style="color: #3a8ee6">{{ userForm.userWallet.balanceSumAll}}<span class="giveFont" v-if="userForm.userWallet.balanceSumAll">（{{userForm.userWallet.balanceSum}} + {{userForm.userWallet.balanceSumGive}}）</span></span></p>
        </template>
        <div v-if="userForm.userWallet">
          <el-descriptions-item label-class-name="my-label" class-name="my-item" label="500账户">{{ userForm.userWallet.balanceSumOne}}<span class="giveFont" v-if="userForm.userWallet.balanceSumOne">（{{ userForm.userWallet.balanceOne}} + {{userForm.userWallet.balanceOneGive}}）</span></el-descriptions-item>
          <el-descriptions-item label-class-name="my-label" class-name="my-item" label="1000账户">{{ userForm.userWallet.balanceSumTwo}}<span class="giveFont"  v-if="userForm.userWallet.balanceSumTwo">（{{ userForm.userWallet.balanceTwo}} + {{userForm.userWallet.balanceTwoGive}}）</span></el-descriptions-item>
          <el-descriptions-item label-class-name="my-label" class-name="my-item" label="1500账户">{{ userForm.userWallet.balanceSumThree}}<span class="giveFont"  v-if="userForm.userWallet.balanceSumThree">（{{ userForm.userWallet.balanceThree}} + {{userForm.userWallet.balanceThreeGive}}）</span></el-descriptions-item>
          <el-descriptions-item label-class-name="my-label" class-name="my-item" label="2500账户">{{ userForm.userWallet.balanceSumFour}}<span class="giveFont"  v-if="userForm.userWallet.balanceSumFour">（{{ userForm.userWallet.balanceFour}} + {{userForm.userWallet.balanceFourGive}}）</span></el-descriptions-item>
        </div>
      </el-descriptions>
    </div>

    <div style="margin-top: 24px;">
      <p class="title">消费项目</p>
      <div class="content-box">
        <el-form ref="formRef" :model="userForm" label-width="90px" label-position="left">
          <div class="pay-top">

            <el-form-item :label="type == 1?'预约宠物：':'服务宠物：'">
              <el-checkbox-group v-model="checkList">
                <div v-for="item of petList" :key="item.id">
                  <el-checkbox :label="item.id" >
                    {{item.petBreedColorName}}{{item.woolState == 1?'短毛':item.woolState == 2?'长毛':''}}（{{item.name}}）<span v-if="item.petAgeMonth">{{item.petAgeMonth.age}}岁{{item.petAgeMonth.month}}个月</span>（{{item.sex == 1?'弟弟':item.sex == 2?'妹妹':'未知'}}）{{item.neuteringState == 1?'已绝育':item.neuteringState == 2?'未绝育':'未知'}}
                    <span v-if="item.exemptionDesc" style="color: red; font-size: 12px">*{{item.exemptionDesc}}</span>
                  </el-checkbox>
                </div>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="消费门店：">
              <span v-if="type == 1 || userForm.type == 1">{{shopName}}</span>
              <el-select v-else v-model="shopId" placeholder="Select" style="width: 25em" @change="shopChange" :disabled="allNum != 0 || preBookId != 0">
                <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

          </div>

          <div class="pay-main">

            <el-form-item>
              <template #label><span style="font-weight: bold">消费项目：</span></template>
              <div style="display: flex">
                <div style="display: flex; align-items: center; cursor:pointer; margin-right: 24px;" @click="addProject(0)">
                  <ElIcons name="CirclePlusFilled" color="#409EFF" :size="20"/>
                  <el-button type="text" style="margin-left: 10px;">添加系统项目</el-button>
                </div>
<!--                <el-tooltip-->
<!--                    class="box-item"-->
<!--                    effect="dark"-->
<!--                    content="门店暂未添加常规项目"-->
<!--                    placement="top"-->
<!--                    v-else-->
<!--                >-->
<!--                  <div style="display: flex; cursor:pointer; align-items: center;  margin-right: 24px;">-->
<!--                    <ElIcons name="CirclePlusFilled" color="#ccc" :size="20"/>-->
<!--                    <el-button type="text" style="margin-left: 10px;" :disabled="true">添加常规项目</el-button>-->
<!--                  </div>-->
<!--                </el-tooltip>-->
                <div style="display: flex; align-items: center; cursor:pointer;margin-right: 24px;" @click="addProject(1)">
                  <ElIcons name="CirclePlusFilled" color="#409EFF" :size="20"/>
                  <el-button type="text" style="margin-left: 10px;">添加自定义项目</el-button>
                </div>
                <div style="display: flex; align-items: center; cursor:pointer;" @click="addProject(2)">
                  <ElIcons name="CirclePlusFilled" color="#409EFF" :size="20"/>
                  <el-button type="text" style="margin-left: 10px;">添加赠送项目</el-button>
                </div>
              </div>
            </el-form-item>

            <div v-if="projectOneList.length > 0" style="margin-bottom: 24px;">
              <div v-for="(item,index) of projectOneList" :key="index">

                <div class="project-list">
                  <div class="delBtn" @click="delProject(index, item)"><ElIcons name="SemiSelect" color="#ffffff" size="10"/></div>

                  <el-row :gutter="8" v-if="item.isSpecial == 0">

                    <el-col :span="5" class="list-item">
                      服务类型：
                      <el-select :disabled="item.disabled" v-model="item.projectServiceType" placeholder="请选择" style="width: 100%;" @change="serviceTypeChange(item.projectServiceType, index)">
                        <el-option v-for="e in serviceTypeList.filter(item => item.serviceType != 12)" :key="e.serviceType" :label="e.name" :value="e.serviceType" :disabled="projectOneList.filter(item => item.projectServiceType == 6).length == 2 && e.serviceType == 6">
                        </el-option>
                      </el-select>
                    </el-col>

                    <el-col :span="item.projectServiceType == 3?13:10" class="list-item">
                      项目：
                      <div v-if="item.projectServiceType == 3" class="commodity-input">
                        <div v-if="!item.disabled" @click="chooseCommodity(index, item)" class="cursor commodity-name">{{item.name?item.name+ (item.retailPrice?'('+item.retailPrice+')':''):'请选择商品'}}</div>
                        <div v-else class="disabled commodity-name">{{item.name}}<span v-if="item.retailPrice">{{item.retailPrice}}</span></div>
                        <el-input-number
                            v-model="item.amount"
                            :min="1"
                            :precision="0"
                            :max="item.surplusNum + item.amount"
                            style="width: 6em;margin-left: 8px;"
                            controls-position="right"
                            @change="getSurplusNum()"
                        />
                      </div>

                      <el-select v-else  v-model="item.projectId" placeholder="请选择" style="width: 100%; flex: 1" @change="projectChange(item.projectId, index)">
                        <el-option v-for="e in item.projectList" :key="e.projectId" :label="e.name + ((e.projectType != 2 && item.projectServiceType != 6)?'(' +  (item.id>0&&e.originalPrice?e.originalPrice:e.oldPrice) + ')': '')" :value="e.projectId">
                        </el-option>
                      </el-select>

                      <el-select v-if="item.projectServiceType == 3" v-model="item.commodityType" placeholder="请选择" style="width: 15em; margin-left: 8px;" @change="commodityTypeChange($event, item)">
                        <el-option v-for="e in commodityTypeList" :key="e.value" :label="e.name" :value="e.value">
                        </el-option>
                      </el-select>
                      <div v-if="item.projectServiceType == 3 && item.commodityType == -2" style="display: flex; align-items: center;margin-left: 10px">金额：<el-input  v-model="item.price" placeholder="请填写" style="width: 100%;flex: 1"/></div>

                    </el-col>

                    <el-col :span="3" class="list-item" v-if="item.projectServiceType != 3">
                      <div v-if="item.projectType == 2" style="display: flex; align-items: center;">张数：<el-input v-model="item.amount" placeholder="请填写" style="width: 100%;flex: 1"/></div>
                      <div v-else-if="item.projectType == 3 || item.projectServiceType == 6" style="display: flex; align-items: center;">次数：<el-input :disabled="item.projectServiceType == 6" v-model="item.amount" placeholder="请填写" style="width: 100%;flex: 1"/></div>
                      <div v-else style="display: flex; align-items: center;">金额：<el-input v-model="item.price" placeholder="请填写" style="width: 100%;flex: 1"/></div>
                    </el-col>

                    <el-col :span="3" class="list-item">
                      负责：
                      <el-select v-model="item.operateAdminId" placeholder="请选择" style="width: 100%;flex: 1">
                        <el-option v-for="e in adminList" :key="e.id" :label="e.name" :value="e.id">
                        </el-option>
                      </el-select>
                    </el-col>

                    <el-col :span="3" class="list-item">
                      猫咪：
                      <el-select v-model="item.petId" placeholder="请选择" style="width: 100%;flex: 1">
                        <el-option v-for="e in petList" :key="e.id" :label="e.name" :value="e.id">
                        </el-option>
                      </el-select>
                    </el-col>

                  </el-row>


                  <el-row :gutter="8" v-if="item.isSpecial == 1">
                    <el-col :span="5" class="list-item">
                      服务类型：
                      <el-select :disabled="item.disabled" v-model="item.projectServiceType" placeholder="请选择" style="width: 100%;" @change="serviceTypeChange(item.projectServiceType, index)">
                        <el-option v-for="e in serviceTypeList.filter(item => item.serviceType != 6 && item.serviceType != 7)" :key="e.serviceType" :label="e.name" :value="e.serviceType">
                        </el-option>
                      </el-select>
                    </el-col>

                    <el-col :span="item.projectServiceType == 1?9:10" class="list-item">
                      项目：
                      <div style="display: flex; align-items: center; width: 100%">
                        <el-input  v-model="item.name" placeholder="请填写" style="width: 100%;flex: 1; margin-right: 8px"/>
                        <!--                        回访天数：-->
                        <el-select style="width: 7em; margin-right: 4px" v-model="item.visitType" placeholder="请选择" @change="visitTypeChange">
                          <el-option v-for="e in visitTypeList" :key="e.value" :label="e.name" :value="e.value">
                          </el-option>
                        </el-select>
                        <el-input v-if="item.visitType == 3" v-model="item.visitDay" placeholder="天数" style="width: 52px;"/>
                      </div>
                    </el-col>

                    <el-col :span="item.projectServiceType == 1?4:3" class="list-item">
                      <el-select v-if="item.projectServiceType == 1"  style="width: 5em; margin-right: 4px" v-model="item.projectType" placeholder="请选择">
                        <el-option v-for="e in projectTypeList" :key="e.projectType" :label="e.name" :value="e.projectType">
                        </el-option>
                      </el-select>
                      <div v-else-if="item.projectServiceType == 6">次数：</div>
                      <div v-else>金额：</div>
                      <el-input v-if="item.projectType != 2 && item.projectServiceType != 6" v-model="item.price" placeholder="金额" style="width: 100%; flex: 1"/>
                      <el-input v-if="item.projectType == 2 || item.projectServiceType == 6" v-model="item.amount" placeholder="次数" style="width: 100%; flex: 1"/>
                    </el-col>

                    <el-col :span="3" class="list-item">
                      负责：
                      <el-select v-model="item.operateAdminId" placeholder="请选择" style="width: 100%;flex: 1">
                        <el-option v-for="e in adminList" :key="e.id" :label="e.name" :value="e.id">
                        </el-option>
                      </el-select>
                    </el-col>

                    <el-col :span="3" class="list-item">
                      猫咪：
                      <el-select v-model="item.petId" placeholder="请选择" style="width: 100%;flex: 1">
                        <el-option v-for="e in petList" :key="e.id" :label="e.name" :value="e.id">
                        </el-option>
                      </el-select>
                    </el-col>

                  </el-row>

                  <el-row :gutter="8" v-if="item.isSpecial == 2">

                    <el-col :span="16" class="list-item">
                      赠送项目：
                      <el-select v-if="item.id == 0" v-model="item.projectGiveId" placeholder="请选择赠送项目" style="width: 100%;" @change="projectGiveChange(item.projectGiveId, index)">
                        <el-option v-for="e in (projectGiveList)" :key="e.id" :label="e.name" :value="e.id" :disabled="e.num == 0">
                          <div style="display: flex; justify-content: space-between; align-items: center">
                            <span>{{e.name}}</span>
                            <span style="color: #c0c4cc">剩余：{{e.num}}</span>
                          </div>
                        </el-option>
                      </el-select>
                      <el-input v-else v-model="item.name" style="width: 100%;" disabled/>
                      <div style="display: flex; align-items: center; margin-left: 8px;" v-if="item.projectId === 0">
                        <!--                        回访天数：-->
                        <el-select style="width: 7em; margin-right: 4px" v-model="item.visitType" placeholder="请选择" @change="visitTypeChange">
                          <el-option v-for="e in visitTypeList" :key="e.value" :label="e.name" :value="e.value">
                          </el-option>
                        </el-select>
                        <el-input v-if="item.visitType == 3" v-model="item.visitDay" placeholder="天数" style="width: 52px;"/>
                      </div>

                    </el-col>


<!--                    <el-col :span="4" class="list-item">-->
<!--                      -->
<!--                    </el-col>-->

                    <el-col :span="4" class="list-item">
                      <label v-if="item.projectType == 2">张数：</label>
                      <el-input v-if="item.projectType == 2" v-model="item.amount" placeholder="请填写" style="width: 100%; margin-right: 16px"/>
                      负责：
                      <el-select v-model="item.operateAdminId" placeholder="请选择" style="width: 100%;">
                        <el-option v-for="e in adminList" :key="e.id" :label="e.name" :value="e.id">
                        </el-option>
                      </el-select>
                    </el-col>

                    <el-col :span="4" class="list-item">
                      猫咪：
                      <el-select v-model="item.petId" placeholder="请选择" style="width: 100%;flex: 1">
                        <el-option v-for="e in petList" :key="e.id" :label="e.name" :value="e.id">
                        </el-option>
                      </el-select>
                    </el-col>

                  </el-row>
                </div>
                <el-row style="color: red; font-size: 12px;margin-bottom: 8px; ">
                  <el-col :span="12"></el-col>
                  <el-col :span="4">
                    <p v-if="item.commodityId > 0" style="margin-left: 18px;">*商品剩余库存: {{ item.surplusNum }}</p>
                  </el-col>
                  <el-col :span="8">
                    <p v-if="item.price < (item.id>0?item.originalPrice:item.oldPrice) && item.projectType != 2 && item.projectServiceType <= 2 && !item.projectGiveId" style="margin-left: 24px">*金额低于门店价，将按门店价计算业绩</p>
                    <p v-if="item.price > (item.id>0?item.originalPrice:item.oldPrice) && item.isSpecial == 0" style="margin-left: 24px">*项目金额不能高于原价</p>
                    <p v-if="item.projectGiveId && item.projectServiceType == 2 || item.projectGiveId && item.projectServiceType == 5" style="margin-left: 0">*赠送项目将按门店价计算业绩</p>
                  </el-col>
                </el-row>
              </div>

            </div>

<!--            <el-form-item label="项目结算：">-->
<!--              <div style="display: flex; flex-wrap: wrap;">-->
<!--                <p>共<span class="payNum">{{ allNum }}</span>项，&nbsp;&nbsp;</p>-->
<!--                <p>总额<span class="payNum">{{ allPayMoney }}</span>元</p>-->
<!--              </div>-->
<!--            </el-form-item>-->
            <div class="pay-sum">
              <div style="display: flex; flex-wrap: wrap;">
                  <p>共<span class="payNum">{{ allNum }}</span>项，&nbsp;&nbsp;</p>
                  <p>总额<span class="payNum">{{ allPayMoney }}</span>元</p>
              </div>
            </div>
          </div>

        </el-form>
      </div>
    </div>
    <div class="dialog-footer" style="text-align: center; margin-top: 8px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">保存</el-button>
    </div>
  </div>
</template>

<script>
import {
  addOrUpdateProjectAll,
  getOperateAdminsList,
  getProjectTypeAndPrice,
  getUserInfo,
  listProjectServiceType
} from '@/api/url'
import {postFormData, postJson, getFormData} from "@/api/api";
import {greaterIntReg, negativeDecimal, positiveIntReg} from '@/assets/shared/reg-constant'
import {add} from "@/assets/shared/util";
import Drawer from "@/assets/js/drawer";
import CommodityList from "@/views/commodity/components/CommodityList";

export default {
  name: "EditPaymentDialog",
  props: {
    value: Object
  },
  data() {
    return {
      idx: this.value.idx,
      userForm: this.value.userForm,

      projectGiveList: this.value.userForm.projectGiveList,
      giveListAll: [],

      // userId: this.value.userId,
      proDetailForm: this.value.proDetailForm,
      // projectOneList: this.value.proDetailForm.projectOneList?this.value.proDetailForm.projectOneList:[],
      projectOneList: [],
      petList: this.value.petList,
      checkList: [],
      preBookPetList: this.value.preBookPetList,
      // deductionMoney: this.value.proDetailForm.deductionMoney?this.value.proDetailForm.deductionMoney:0,

      adminList: [],
      projectList: [],
      serviceTypeList: [],

      preBookId: this.value.preBookId?this.value.preBookId:0,
      type: this.value.type?this.value.type:0,

      shopId: this.value.shopId,
      shopName: this.value.shopName,
      shopIdArray: JSON.parse(sessionStorage.getItem('ownShopList')).filter(item => item.isEdit == 1),

      // shopDis: this.value.idx > -1?true:false,

      projectTypeList: [
        {name: '金额', projectType: 1},
        {name: '张数', projectType: 2},
      ],

      visitTypeList: [
        {name: '无需回访', value: 1},
        {name: '立即回访', value: 2},
        {name: '回访天数', value: 3},
      ],
      // visitType: 1,

      // stockArr: [],

      commodityTypeList: [
        {name: '商品售卖', value: -2},
        {name: '商品赠送', value: -3},
        {name: '核销券码', value: -5},
      ],

    }
  },
  computed:{

    projectState() {
      let state = false
      if(this.projectList.length > 0){
        state = true
      }
      return state
    },
    allNum() {
      // let projectArr = this.projectOneList.filter(item => item.isDel == 0)
      return this.projectOneList.length
    },
    allPayMoney() {
      let allMoney = 0
      this.projectOneList.map(item => {
        if(item.commodityId > 0) {
          allMoney += Number(item.price)*item.amount
        }else {
          allMoney += Number(item.price)
        }
      })
      return allMoney.toFixed(2)
    },
  },
  methods: {

    commodityTypeChange(val, item) {
      if(val == -2) {
        item.price = item.oldPrice
      }else {
        item.price = 0
      }
      console.log(item.price)
    },

    visitTypeChange() {
      this.projectOneList.map(item => {
        if(item.visitType == 1) {
          item.visitDay = -1
        }
        if(item.visitType == 2) {
          item.visitDay = 0
        }
        if(item.visitType == 3) {
          if(item.visitDay <= 0) {
            item.visitDay = ''
          }
        }
      })
    },

    cancel() {
      this.$emit("close");
    },

    summit() {
      console.log(this.projectOneList)
      if(this.checkList.length == 0 && this.preBookId > 0 && this.type != 2) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请先勾选需要预约的宠物',
          type: 'warning'
        });
        return false
      }
      if(this.projectOneList.length == 0 && this.idx == -1) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请添加消费项目',
          type: 'warning'
        });
        return false
      }

      let pList = this.projectOneList.filter(item => item.projectServiceType == 6)
      if(pList.length == 2 && pList[0].projectId == pList[1].projectId) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '接猫、送猫项目只能各添加一次',
          type: 'warning'
        });
        return false
      }
      if(this.projectOneList.length > 0) {
        for(let i=0; i<this.projectOneList.length; i++) {

          //系统项目
          if(this.projectOneList[i].isSpecial == 0) {

            if(!this.projectOneList[i].projectId  && this.projectOneList[i].projectServiceType != 3) {
              this.$message({
                showClose: true,
                duration: 2000,
                message: '常规项目名不能为空',
                type: 'warning'
              });
              return false
            }

            if(!this.projectOneList[i].name && this.projectOneList[i].projectServiceType == 3) {
              this.$message({
                showClose: true,
                duration: 2000,
                message: '请选择商品',
                type: 'warning'
              });
              return false
            }

            if(!this.projectOneList[i].amount && this.projectOneList[i].projectServiceType == 3) {
              this.$message({
                showClose: true,
                duration: 2000,
                message: '请输入商品数量',
                type: 'warning'
              });
              return false
            }

            if(this.projectOneList[i].projectType == 1 && !negativeDecimal.test(this.projectOneList[i].price) && this.projectOneList[i].projectServiceType != 6 ){
              this.$message({
                showClose: true,
                duration: 2000,
                message: '请输入正确的金额',
                type: 'warning'
              });
              return false
            }

            if(this.projectOneList[i].projectServiceType == 6 && !greaterIntReg.test(this.projectOneList[i].amount)){
              this.$message({
                showClose: true,
                duration: 2000,
                message: '请输入正确的次数',
                type: 'warning'
              });
              return false
            }

            if(this.projectOneList[i].projectServiceType == 8) {
              if(!this.projectOneList[i].petId) {
                this.$message({
                  showClose: true,
                  duration: 2000,
                  message: '猫咪不能为空',
                  type: 'warning'
                });
                return false
              }
            }

            if(this.projectOneList[i].price > (this.projectOneList[i].id > 0?this.projectOneList[i].originalPrice:this.projectOneList[i].oldPrice)) {
              this.$message({
                showClose: true,
                duration: 2000,
                message: '项目金额不能高于原价',
                type: 'warning'
              });
              return false
            }

          }

          //自定义项目
          if(this.projectOneList[i].isSpecial == 1) {

            if(!this.projectOneList[i].name ) {
              this.$message({
                showClose: true,
                duration: 2000,
                message: '特殊项目名不能为空',
                type: 'warning'
              });
              return false
            }

            if(this.projectOneList[i].visitType == 3 && !greaterIntReg.test(this.projectOneList[i].visitDay)) {
              this.$message({
                showClose: true,
                duration: 2000,
                message: '请输入正确的回访天数',
                type: 'warning'
              });
              return false
            }

            if(this.projectOneList[i].projectType == 1 && !negativeDecimal.test(this.projectOneList[i].price) && this.projectOneList[i].projectServiceType != 6 ){
              this.$message({
                showClose: true,
                duration: 2000,
                message: '请输入正确的金额',
                type: 'warning'
              });
              return false
            }

            if(this.projectOneList[i].projectServiceType == 6 && !greaterIntReg.test(this.projectOneList[i].amount)){
              this.$message({
                showClose: true,
                duration: 2000,
                message: '请输入正确的次数',
                type: 'warning'
              });
              return false
            }


          }

          //赠送项目
          if(this.projectOneList[i].isSpecial == 2) {

            if(!this.projectOneList[i].projectGiveId) {
              this.$message({
                showClose: true,
                duration: 2000,
                message: '请选择赠送项目',
                type: 'warning'
              });
              return false
            }

            if(this.projectOneList[i].visitType == 3 && !greaterIntReg.test(this.projectOneList[i].visitDay)) {
              this.$message({
                showClose: true,
                duration: 2000,
                message: '请输入正确的回访天数',
                type: 'warning'
              });
              return false
            }

          }


          if(this.projectOneList[i].projectType == 2 && !greaterIntReg.test(this.projectOneList[i].amount)){
            this.$message({
              showClose: true,
              duration: 2000,
              message: '请输入正确的张数',
              type: 'warning'
            });
            return false
          }


          if(!this.projectOneList[i].operateAdminId) {
            this.$message({
              showClose: true,
              duration: 2000,
              message: '负责人不能为空',
              type: 'warning'
            });
            return false
          }

          if(this.projectOneList[i].projectServiceType == 1 || this.projectOneList[i].projectServiceType == 2 || this.projectOneList[i].projectServiceType == 9) {
            if(!this.projectOneList[i].petId) {
              this.$message({
                showClose: true,
                duration: 2000,
                message: '猫咪不能为空',
                type: 'warning'
              });
              return false
            }
          }


        }
      }
      let param = {}
      param['id'] = this.preBookId?this.preBookId:0;
      param['userId'] = this.userForm.id;
      // param['preBookId'] = this.preBookId;
      // param['petIdArr'] = this.checkList;

      let arr = []
      this.checkList.map(item => {
        let obj = {}
        for(let i=0; i<this.petList.length; i++) {
          if(item == this.petList[i].id) {
            obj.id = this.petList[i].id
            obj.weight = this.petList[i].weight
          }
        }
        arr.push(obj)
      })
      param['petList'] = arr;

      param['shopId'] = this.shopId;
      param['projectOneReqList'] = this.projectOneList;
      postJson(addOrUpdateProjectAll, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', data.data)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },

    delProject(idx, item) {
      this.projectOneList.splice(idx, 1)

      this.getSurplusNum()

      if(item.projectGiveId > 0) {
        this.projectGiveList.map(p => {
          if(p.id == item.projectGiveId) {
            p.num ++
          }
        })
      }

    },

    shopChange(val) {
      this.adminList = []
      this.projectList = []
      // this.projectOneList.map((item,index) => {
      //   this.delProject(index, item)
      // })
      this.getAdminList(val)
      this.getProjectList(val)
    },


    getAdminList(id, reset) {
      getFormData(getOperateAdminsList, {id: id, loginState: 1}).then(data => {
         if(data.code == 200) {
           this.adminList = data.data
           // if(reset && this.projectOneList.length > 0) {
           //   this.projectOneList.map(item => {
           //     item.operateAdminId = ''
           //   })
           // }
         }
      })
    },

    getProjectList() {
      let param = {}
      param['shopId'] = this.shopId
      param['userId'] = this.userForm.id
      getFormData(getProjectTypeAndPrice, param).then(data => {
        if(data.code == 200) {
          this.projectList = data.data
          if(this.idx > -1) {
            this.projectOneList.map(item => {

              if(item.projectGiveId) {
                item.isSpecial = 2
              }else if(item.projectId == 0 && item.commodityId == 0) {
                item.isSpecial = 1
              }else {
                item.isSpecial = 0
              }
              let list = []
              this.projectList.map(e => {
                e.originalPrice = e.oldPrice
                if(item.projectId == e.projectId) {
                  item.oldPrice = e.oldPrice
                  e.originalPrice = item.originalPrice
                }
                if(item.projectServiceType == e.serviceType) {
                  list.push(e)
                }
              })
              item.projectList = list

              if(item.commodityId > 0) {
                item.disabled = true
                item.surplusNum = item.stockNum
                item.sumNum = 0

                this.projectOneList.map(s => {
                  if(item.commodityId == s.commodityId) {
                    item.sumNum += s.amount
                  }
                })

              }

            })

            this.projectOneList.map(item => {
              item.stockNum += item.sumNum
            })

            console.log(this.projectOneList)

          }
        }
      })
    },

    getServiceTypeList() {
      getFormData(listProjectServiceType).then(data => {
        if(data.code == 200) {
          this.serviceTypeList = data.data
        }
      })
    },

    projectChange(id, idx) {
      for(let i=0; i<this.projectOneList[idx].projectList.length; i++) {
        if(id == this.projectOneList[idx].projectList[i].projectId) {
          this.projectOneList[idx].price = this.projectOneList[idx].projectList[i].price
          this.projectOneList[idx].oldPrice = this.projectOneList[idx].projectList[i].oldPrice
          this.projectOneList[idx].originalPrice = this.projectOneList[idx].projectList[i].originalPrice
          this.projectOneList[idx].amount = this.projectOneList[idx].projectList[i].amount
          this.projectOneList[idx].projectType = this.projectOneList[idx].projectList[i].projectType
        }
      }
    },

    serviceTypeChange(type, idx) {
      if(this.projectOneList[idx].isSpecial == 0 ) {
        let list = []
        this.projectList.map(item => {
          if(item.serviceType == type) {
           list.push(item)
          }
        })
        this.projectOneList[idx].projectId = type == 3?0:''
        this.projectOneList[idx].projectList = list
      }
      this.projectOneList[idx].projectType = type == 6?3:1
      this.projectOneList[idx].commodityId = 0
      this.projectOneList[idx].name = ''
    },

    projectGiveChange(giveId, idx) {
      for(let i=0; i<this.projectGiveList.length; i++) {
        if(this.projectGiveList[i].id == giveId) {
          this.projectOneList[idx].name = this.projectGiveList[i].name
          this.projectOneList[idx].price = this.projectGiveList[i].price
          // this.projectOneList[idx].num = this.projectGiveList[i].num
          this.projectOneList[idx].projectId = this.projectGiveList[i].projectId
          this.projectOneList[idx].projectType = this.projectGiveList[i].projectType
          this.projectOneList[idx].projectServiceType = this.projectGiveList[i].serviceType
          // if(this.projectGiveList[i].num > 0) {
          //   this.projectGiveList[i].num --
          // }
          break;
        }
      }
      this.projectGiveList = JSON.parse(JSON.stringify(this.giveListAll))
      for(let j=0; j<this.projectOneList.length; j++) {
        if(this.projectOneList[j].projectGiveId > 0) {
          for(let k=0; k<this.projectGiveList.length; k++) {
            if(this.projectOneList[j].projectGiveId == this.projectGiveList[k].id) {
              if(this.projectGiveList[k].num > 0) {
                this.projectGiveList[k].num --
              }
            }
          }
        }
      }

    },

    addProject(special) {
      // if(this.projectList.length == 0 && !special) {
      //   this.$message({
      //     showClose: true,
      //     duration: 2000,
      //     message: '门店暂未添加常规项目',
      //     type: 'warning'
      //   });
      //   return false
      // }
      let obj = {
        id: 0,
        // projectId: special?0:'',
        operateAdminId: this.projectOneList.length > 0?this.projectOneList[this.projectOneList.length -1].operateAdminId:'',
        projectType: 1,
        amount: '',
        price: special == 2?0:'',
        oldPrice: '',
        originalPrice: '',
        name: '',
        isSpecial: special,
        projectServiceType: special == 1?3:this.projectOneList.length > 0 && this.projectOneList[this.projectOneList.length -1].projectServiceType != 6?this.projectOneList[this.projectOneList.length -1].projectServiceType:1,
        projectId: special == 1?0:this.projectOneList.length > 0 && this.projectOneList[this.projectOneList.length -1].projectServiceType == 3?0:'',
        projectList: [],

        // commodityId: special?0:'',
        commodityId: 0,
        commodityName: '',
        visitType: 1,
        visitDay: -1,
        projectGiveId: special == 2?'':0,
        commodityType: -2,
        petId: '',
        // num: '', //赠送数量
      }
      let list = []
      this.projectList.map(item => {
        if(item.serviceType == obj.projectServiceType) {
          list.push(item)
        }
      })
      obj.projectList = list
      this.projectOneList.push(obj)
      console.log(this.projectOneList)
    },

    chooseCommodity(idx) {
      let _title = '';
      _title = '商品列表'
      Drawer.open({
        title: _title,
        component: CommodityList,
        data: {
          width: 800,
          from: 2,
          shopId: this.shopId,
          userId: this.userForm.id,
        },
        confirm: (result) => {
          for(let i=0; i<this.projectOneList.length; i++) {
            if(this.projectOneList[i].commodityId == result.commodityId && this.projectOneList[i].surplusNum == 0) {
              this.$message({
                showClose: true,
                duration: 2000,
                message: '该商品库存不足',
                type: 'warning'
              });
              return false
            }
          }

          if(this.idx > -1) {
            if(this.projectOneList.some(item => item.commodityId == result.commodityId)) {
              for(let i=0; i<this.projectOneList.length; i++) {
                if(this.projectOneList[i].commodityId == result.commodityId) {
                  this.projectOneList[idx].stockNum = this.projectOneList[i].stockNum
                  break;
                }
              }
            }else {
              this.projectOneList[idx].stockNum = result.stockNum
            }
          }else {
            this.projectOneList[idx].stockNum = result.stockNum
          }

          this.projectOneList[idx].commodityId = result.commodityId
          this.projectOneList[idx].name = result.commodityName
          if(this.projectOneList[idx].commodityType == -2) {
            this.projectOneList[idx].price = result.price
          }else {
            this.projectOneList[idx].price = 0
          }
          this.projectOneList[idx].oldPrice = result.price
          this.projectOneList[idx].retailPrice = result.retailPrice

          this.getSurplusNum()

        }
      })
    },

    //计算剩余库存
    getSurplusNum() {
      this.projectOneList.map(item => {
        if(item.commodityId > 0) {
          item.sumNum = 0
          this.projectOneList.map(s => {
            if(item.commodityId == s.commodityId) {
              item.sumNum += s.amount
            }
          })
        }
      })

      this.projectOneList.map(item => {
        item.surplusNum = item.stockNum - item.sumNum
      })

    },

    // getUserInfo(id) {
    //   let param = {};
    //   param['id'] = id;
    //   getFormData(getUserInfo, param).then((data)=>{
    //     let {code, msg} = data;
    //     if (code == 200) {
    //       this.userForm = data.data
    //       this.userForm.userWallet.paySum = add([this.userForm.userWallet.paySumOne, this.userForm.userWallet.paySumTwo, this.userForm.userWallet.paySumThree, this.userForm.userWallet.paySumFour, this.userForm.userWallet.paySumOneGive, this.userForm.userWallet.paySumTwoGive, this.userForm.userWallet.paySumThreeGive, this.userForm.userWallet.paySumFourGive])
    //       this.userForm.userWallet.balanceSum = add([this.userForm.userWallet.balanceOne, this.userForm.userWallet.balanceTwo, this.userForm.userWallet.balanceThree, this.userForm.userWallet.balanceFour, this.userForm.userWallet.balanceOneGive, this.userForm.userWallet.balanceTwoGive, this.userForm.userWallet.balanceThreeGive, this.userForm.userWallet.balanceFourGive])
    //     }else {
    //       this.$message({
    //         showClose: true,
    //         duration: 1000,
    //         message: msg,
    //         type: 'warning'
    //       })
    //     }
    //   }).catch(()=> {
    //   })
    // },


  },
  mounted() {
    console.log(this.userForm)
    this.giveListAll = JSON.parse(JSON.stringify(this.projectGiveList))
    // if(this.idx > -1) {
      // for(let i=0; i<this.proDetailForm.petIdList.length; i++) {
      //   for(let j=0; j<this.userForm.petList.length; j++) {
      //     if(this.proDetailForm.petIdList[i] == this.userForm.petList[j].id) {
      //       this.checkList.push(this.userForm.petList[j].id)
      //     }
      //   }
      // }
    //   this.checkList = this.proDetailForm.petIdList
    // }
    // this.userForm.userWallet.balanceSum = add([this.userForm.userWallet.balanceOne, this.userForm.userWallet.balanceTwo, this.userForm.userWallet.balanceThree, this.userForm.userWallet.balanceFour])
    this.userForm.userWallet.balanceSum = add([this.userForm.userWallet.balanceOne, this.userForm.userWallet.balanceTwo, this.userForm.userWallet.balanceThree, this.userForm.userWallet.balanceFour])
    this.userForm.userWallet.balanceSumGive = add([this.userForm.userWallet.balanceOneGive, this.userForm.userWallet.balanceTwoGive, this.userForm.userWallet.balanceThreeGive, this.userForm.userWallet.balanceFourGive])
    this.userForm.userWallet.balanceSumAll = add([this.userForm.userWallet.balanceSum, this.userForm.userWallet.balanceSumGive])
    this.userForm.userWallet.balanceSumOne = add([this.userForm.userWallet.balanceOne, this.userForm.userWallet.balanceOneGive])
    this.userForm.userWallet.balanceSumTwo = add([this.userForm.userWallet.balanceTwo, this.userForm.userWallet.balanceTwoGive])
    this.userForm.userWallet.balanceSumThree = add([this.userForm.userWallet.balanceThree, this.userForm.userWallet.balanceThreeGive])
    this.userForm.userWallet.balanceSumFour = add([this.userForm.userWallet.balanceFour, this.userForm.userWallet.balanceFourGive])
    if(!this.shopId) {
      if(this.shopIdArray.some(e => e.id == this.userForm.shopId)) {
        this.shopId = this.userForm.shopId
      }else {
        this.shopId = this.shopIdArray[0].id
      }
    }
    this.getAdminList(this.shopId);
    // this.getProjectList(this.shopId);
    this.getServiceTypeList()
    this.getProjectList()


    if(this.idx > -1) {
      this.projectOneList = [...this.proDetailForm.projectOneList];
      this.projectOneList.map(item => {
        item.projectGiveId = item.projectGiveId?item.projectGiveId:0
        item.visitType = ''
        if(item.visitDay == -1) {
          item.visitType = 1
        }
        if(item.visitDay == 0) {
          item.visitType = 2
        }
        if(item.visitDay > 0) {
          item.visitType = 3
        }
        if(item.petId == 0) {
          item.petId = ''
        }
      })
    }

    // this.preBookPetList.map(pet => {
    //   this.checkList.push(pet.petId)
    // })

    this.petList.map(item => {
      item.weight = ''
      this.preBookPetList.map(pet => {
        if(pet.petId == item.id) {
          item.weight = pet.weight
          this.checkList.push(pet.petId)
        }
      })
    })

  },
}
</script>

<style scoped>
.title {
  font-weight: bold;
  color: #303133;
}
.content-box {
  border: 1px solid #ebeef5;
  padding: 24px 0 16px;
  margin-top: 12px;
  /*cursor: pointer;*/
  /*font-size: 13px;*/
  /*border-radius: 16px;*/
}

.pay-top {
  margin: 0 60px 16px;
}

.pay-main {
  background-color: #f7f9fc;
  margin: 32px 32px 16px;
  padding: 32px 32px 16px;
  border-radius: 16px;
}

.pay-sum {
  border-top: 1px solid #e8e8e8;
  padding: 16px 0;
  font-size: 13px;
}

.project-list {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.list-item {
  /*margin-left: 12px;*/
  display: flex;
  align-items: center;
  white-space: nowrap;
  /*width: 24%;*/
}
.delBtn {
  background-color: #bbbbbb;
  color: #ffffff;
  height: 18px;
  width: 18px;
  border-radius: 9px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  line-height: 10px;
  cursor: pointer;
  flex-shrink: 0;
  margin-right: 8px;
}
.delBtn:hover {
  background-color: red;
}
.payNum {
  /*font-size: 16px;*/
  font-weight: bold;
  margin: 0 4px;
}

.commodity-input {
  display: flex;
  width: 100%;
  /*flex: 1;*/
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background-color: #ffffff;
  height: 32px;
  padding: 0 0 0 10px;
  justify-content: space-between;
  align-items: center;
}


.commodity-name {
  /*width: 100%;*/
  max-width: 140px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.cursor {
  cursor: pointer;
}

.disabled {
  color: #999999;
}

el-row {
  width: 100%;
}

</style>
